import {useGoVehisService} from "../../utils/axios";
import React, {useEffect, useState} from "react";
import { Badge, Button, Chip, Table, TableBody } from '@material-ui/core';
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import FileUploadIcon from '@material-ui/icons/CloudUpload';
import AkolDealerNoteDialog from './AkolDealerNoteDialog';

function AkolDealerList() {
  const goVehisService = useGoVehisService();
  const [logs, setLogs] = useState([])
  const [openNoteDialog, setOpenNoteDialog] = useState(false);
  const [selectedDealerNip, setSelectedDealerNip] = useState(null);
  const [selectedDealerNote, setSelectedDealerNote] = useState('');

  function reload() {
    goVehisService.get("/admin/akol/dealers").then(
      res => setLogs(res.data)
    )
  }

  useEffect(() => {
    reload();
  }, [])

  function changeStatus(nip) {
    goVehisService.post("/admin/akol/dealers/" + nip + "/status")
      .then(d => reload());
  }
  function blockDescription(nip) {
    goVehisService.post("/admin/akol/dealers/" + nip + "/blockDescription")
      .then(d => reload());
  }

  function changeKeepOffers(nip) {
    goVehisService.post("/admin/akol/dealers/" + nip + "/keepOffers")
      .then(d => reload());
  }

  function handleNoteClick(nip, note) {
    setSelectedDealerNip(nip);
    setSelectedDealerNote(note);
    setOpenNoteDialog(true);
  }

  function handleNoteDialogClose() {
    setOpenNoteDialog(false);
    setSelectedDealerNip(null);
    setSelectedDealerNote('');
  }

  function handleNoteSaved() {
    reload();
  }

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nazwa</TableCell>
            <TableCell>NIP</TableCell>
            <TableCell>Miasto</TableCell>
            <TableCell>Telefon</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Czy trwale trzymać oferty?</TableCell>
            <TableCell>Czy blokować opis?</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            logs.map((log) => (
              <TableRow key={log.nip}>
                <TableCell>{log.name}</TableCell>
                <TableCell>{log.nip}</TableCell>
                <TableCell>{log.city}</TableCell>
                <TableCell>{log.phone}</TableCell>
                <TableCell>{log.email}</TableCell>
                <TableCell>
                  {log.isActive &&   <Chip label="Aktywny" color="primary" sx={{cursor: "pointer"}} onClick={() => changeStatus(log.nip)}/>}
                  {!log.isActive &&   <Chip label="Nieaktywny" color="secondary"  sx={{cursor: "pointer"}} onClick={() => changeStatus(log.nip)}/>}
                </TableCell>
                <TableCell>
                  {log.keepOffers &&   <Chip label="Tak" color="primary" sx={{cursor: "pointer"}} onClick={() => changeKeepOffers(log.nip)}/>}
                  {!log.keepOffers &&   <Chip label="Nie" color="secondary"  sx={{cursor: "pointer"}} onClick={() => changeKeepOffers(log.nip)}/>}
                </TableCell>
                <TableCell>
                  {log.blockDescription &&   <Chip label="Tak" color="secondary" sx={{cursor: "pointer"}} onClick={() => blockDescription(log.nip)}/>}
                  {!log.blockDescription &&   <Chip label="Nie" color="primary"  sx={{cursor: "pointer"}} onClick={() => blockDescription(log.nip)}/>}
                </TableCell>
                <TableCell>
                  <Button onClick={() => handleNoteClick(log.nip, log.note)}>
                    Notatka
                  </Button>
                </TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>

      <AkolDealerNoteDialog
        isOpen={openNoteDialog}
        onClose={handleNoteDialogClose}
        dealerNip={selectedDealerNip}
        initialNote={selectedDealerNote}
        onSave={handleNoteSaved}
      />
    </>
  )
}

export default AkolDealerList;
